const setStudyAreaFilters = (strudyAreaFilter) =>
  strudyAreaFilter.map((filter) => ({
    ...filter,
    ...{ name: filter?.name },
  }));

export default setStudyAreaFilters;
